export default {
  actionTypes: {
    registerSupplier: 'REGISTRATION_REGISTER_SUPPLIER',
    completeSupplierRegistration: 'REGISTRATION_COMPLETE_SUPPLIER_REGISTRATION',
    validateConfirmationToken: 'REGISTRATION_VALIDATE_SUPPLIER_TOKEN',
  },
  mutationTypes: {
    setEmailConfirmationLoading: 'REGISTRATION_SET_EMAIL_CONFIRMATION_LOADING',
  },
};
